import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import './i18n';
import './styles/maf-scrollbar.css';
import App from './App';
import { theme } from './app/theme';
import { AuthProvider } from './auth/AuthContext';

const root = createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeProvider>,
);
